// Lightweight UA sniffing for the mobile app banner.
// We avoid pulling in a library (ua-parser-js etc.) — the checks here only need to be
// good enough to decide "show the banner or not."

const ua = (): string =>
	typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

export const isIOS = (): boolean => /iPad|iPhone|iPod/.test(ua());

export const isAndroid = (): boolean => /Android/.test(ua());

// True only for native Safari on iOS — NOT Chrome/Firefox-on-iOS.
// iOS Safari handles the smart app banner natively via <meta name="apple-itunes-app">,
// so we suppress our custom banner there to avoid showing two banners stacked.
export const isIOSSafari = (): boolean => {
	const u = ua();
	return /iPad|iPhone|iPod/.test(u) && /Safari/.test(u) && !/CriOS|FxiOS|EdgiOS/.test(u);
};

// True if the user is on a phone-class mobile browser (iOS or Android).
// Tablets are intentionally excluded — banner is for handheld mobile UX, not iPad.
// If product wants tablets included later, drop the screen-width gate.
export const isMobileBrowser = (): boolean => {
	if (typeof window === 'undefined') return false;
	const isMobileUA = isIOS() || isAndroid();
	const isHandheldWidth = window.innerWidth <= 768;
	return isMobileUA && isHandheldWidth;
};
